module.exports = __webpack_public_path__ + "static/media/nonrating.967939a3.png";